// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"no-result-filled"},"nodeName":"g","children":[{"attributes":{"id":"Union"},"nodeName":"g","children":[{"attributes":{"fill":"currentColor","d":"M11 0H13V4H11V0Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M5.00098 0.585786L3.58676 2L6.50098 4.91421L7.91519 3.5L5.00098 0.585786Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M1 13.7344L5.41968 6H18.5803L23 13.7344V22H1V13.7344ZM6.58032 8L3.72318 13H8.90123L9.09445 13.7507C9.42754 15.0449 10.6035 16 12 16C13.3965 16 14.5725 15.0449 14.9055 13.7507L15.0988 13H20.2768L17.4197 8H6.58032Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.999 0.585786L16.0848 3.5L17.499 4.91421L20.4132 2L18.999 0.585786Z"},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-no-result-filled')
export default class NoResultFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'no-result-filled',
    }
  }
}
